
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/total-cost-of-ownership",
      function () {
        return require("private-next-pages/total-cost-of-ownership.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/total-cost-of-ownership"])
      });
    }
  